import React from 'react';
import '../SharedControlPanel.scss';
import './OverlayPanel.scss';
import VerticalPaddingInput from '../../../../InputComponents/VerticalPaddingInput/VerticalPaddingInput';
import HorizontalPaddingInput from '../../../../InputComponents/HorizontalPaddingInput/HorizontalPaddingInput';
import LineSpacingInput from '../../../../InputComponents/LineSpacingInput/LineSpacingInput';
import VerticalOffsetInput from '../../../../InputComponents/VerticalOffsetInput/VerticalOffsetInput';
import LineInput from '../../../../InputComponents/LineInput/LineInput';
import FontFamilyInput from '../../../../InputComponents/FontFamilyInput/FontFamilyInput';
import OrientationInput from '../../../../InputComponents/OrientationInput/OrientationInput';
import StyleInput from '../../../../InputComponents/StyleInput/StyleInput';
import FontSizeInput from '../../../../InputComponents/FontSizeInput/FontSizeInput';
import FontColourInput from '../../../../InputComponents/FontColourInput/FontColourInput';
import BackgroundColourInput from '../../../../InputComponents/BackgroundColourInput/BackgroundColourInput';
import FpsInput from '../../../../InputComponents/FpsInput/FpsInput';
import AutoHideInput from '../../../../InputComponents/AutoHideInput/AutoHideInput';
import useProject from '../../../../../hooks/useProject';

const OverlayPanel = () => {
  const { project } = useProject();

  return (
    <div className="overlay-panel">
      {/* Layout */}
      <div className="overlay-panel-section level">
        <div className="overlay-panel-section-content-value">
          <div className="overlay-panel-column">
            <StyleInput />
          </div>
          <div className="overlay-panel-column">
            <OrientationInput />
          </div>
          <div className="overlay-panel-column">
            <LineInput />
          </div>
        </div>
      </div>

      <div className="overlay-panel-section level">
        <div className="overlay-panel-section-content-value">
          <div className="overlay-panel-column">
            <VerticalPaddingInput />
          </div>
          <div className="overlay-panel-column">
            <HorizontalPaddingInput />
          </div>
          <div className="overlay-panel-column">
            <LineSpacingInput />
          </div>
        </div>
      </div>

      <div className="overlay-panel-section level">
        <div className="overlay-panel-section-content-value">
          <div className="overlay-panel-column">
            <VerticalOffsetInput />
          </div>
        </div>
      </div>

      <div className="overlay-panel-section level">
        <div className="overlay-panel-section-content-value">
          <div className="overlay-panel-column">
            <FontFamilyInput />
          </div>

          <div className="overlay-panel-column">
            <FontSizeInput />
          </div>
        </div>
      </div>

      <div className="overlay-panel-section level">
        <div className="overlay-panel-section-content-value">
          <FontColourInput />
        </div>
      </div>

      <div className="overlay-panel-section level">
        <div className="overlay-panel-section-content-value">
          {project?.createdByUser?.isAdmin === true && (
          <>
            <div className="overlay-panel-column">
              <FpsInput />
            </div>
            <div className="overlay-panel-column">
              <AutoHideInput />
            </div>
          </>
          )}
        </div>
      </div>

      <div className="overlay-panel-section level">
        <div className="overlay-panel-section-content-value">
          <BackgroundColourInput />
        </div>
      </div>
    </div>
  );
};

export default React.memo(OverlayPanel);
